import type { FunctionComponent } from 'react';
import { CardHeader, CardTitle } from '@/components';
import { ctw } from '@/common';
import type { AccordionTitle } from '@/components/molecules/AccordionCard/types';

export const AccordionCardTitle: FunctionComponent<AccordionTitle> = ({
  className,
  children,
  cardTitleProps,
  leftChildren,
  rightChildren,
  ...props
}) => {
  return (
    <CardHeader {...props} className={ctw(`pb-2`, className)}>
      {leftChildren}
      <CardTitle {...cardTitleProps} className={ctw(`text-xl`, cardTitleProps?.className)}>
        {children}
      </CardTitle>
      {rightChildren}
    </CardHeader>
  );
};

AccordionCardTitle.displayName = 'Accordion.Title';
